module.exports = __webpack_public_path__ + "static/GT-Super-Display-Light-Italic-de15ba7e9e7f0c80c1a91aa26d5d3eec.woff2";